import EventsBox from "components/company/v3/boxes/EventsBox";
import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import type { CompanyEventsTabEnum } from "components/company/v3/menu/enums";
import type { EventsCalendarState } from "components/investorrelations/EventsCalendarLocalState";
import { IIssuerType } from "types/graphqlTypes";

interface AmericanEventsBoxProps extends EventsCalendarState {
  tickerSymbol: string;
  isRenderPageDefault?: boolean;
  tab: CompanyEventsTabEnum;
  onChangeTab: (tab: CompanyEventsTabEnum) => void;
}

export default function AmericanEventsBox({
  tickerSymbol,
  isRenderPageDefault = false,
  tab,
  onChangeTab,
  ...filterState
}: AmericanEventsBoxProps) {
  const issuer = useAmericanIssuer();

  return (
    <EventsBox
      tickerSymbol={tickerSymbol}
      context="STOCKS"
      isRenderPageDefault={isRenderPageDefault}
      tab={tab}
      onChangeTab={onChangeTab}
      corporateActionsTickerSymbols={issuer.securities.map((node) => node.tickerSymbol)}
      {...filterState}
      issuerType={issuer.isREIT ? IIssuerType.AmericanReit : IIssuerType.AmericanCompany}
    />
  );
}
